/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPLANGUAGE } from './IAPLANGUAGE';
import {
    IAPLANGUAGEFromJSON,
    IAPLANGUAGEFromJSONTyped,
    IAPLANGUAGEToJSON,
} from './IAPLANGUAGE';

/**
 * 
 * @export
 * @interface LookupTypeResponseModel
 */
export interface LookupTypeResponseModel {
    /**
     * 
     * @type {string}
     * @memberof LookupTypeResponseModel
     */
    lookupType: string;
    /**
     * 
     * @type {string}
     * @memberof LookupTypeResponseModel
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof LookupTypeResponseModel
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof LookupTypeResponseModel
     */
    extendedDescription?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LookupTypeResponseModel
     */
    isEnum: boolean;
    /**
     * 
     * @type {IAPLANGUAGE}
     * @memberof LookupTypeResponseModel
     */
    languageId: IAPLANGUAGE;
}

/**
 * Check if a given object implements the LookupTypeResponseModel interface.
 */
export function instanceOfLookupTypeResponseModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lookupType" in value;
    isInstance = isInstance && "value" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "isEnum" in value;
    isInstance = isInstance && "languageId" in value;

    return isInstance;
}

export function LookupTypeResponseModelFromJSON(json: any): LookupTypeResponseModel {
    return LookupTypeResponseModelFromJSONTyped(json, false);
}

export function LookupTypeResponseModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupTypeResponseModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lookupType': json['LookupType'],
        'value': json['Value'],
        'description': json['Description'],
        'extendedDescription': !exists(json, 'ExtendedDescription') ? undefined : json['ExtendedDescription'],
        'isEnum': json['IsEnum'],
        'languageId': IAPLANGUAGEFromJSON(json['LanguageId']),
    };
}

export function LookupTypeResponseModelToJSON(value?: LookupTypeResponseModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'LookupType': value.lookupType,
        'Value': value.value,
        'Description': value.description,
        'ExtendedDescription': value.extendedDescription,
        'IsEnum': value.isEnum,
        'LanguageId': IAPLANGUAGEToJSON(value.languageId),
    };
}

